import { call, put, takeEvery } from 'redux-saga/effects';
import {
    FETCH_ACTIVITY_SUBCOVERAGES_REQUEST,
    FETCH_ACTIVITY_SUBCOVERAGES_SUCCESS,
    FETCH_ACTIVITY_SUBCOVERAGES_FAILURE,
    FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_REQUEST,
    FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_SUCCESS,
    FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_FAILURE,
    CREATE_ACTIVITY_SUBCOVERAGE_REQUEST,
    CREATE_ACTIVITY_SUBCOVERAGE_SUCCESS,
    CREATE_ACTIVITY_SUBCOVERAGE_FAILURE,
    UPDATE_ACTIVITY_SUBCOVERAGE_REQUEST,
    UPDATE_ACTIVITY_SUBCOVERAGE_SUCCESS,
    UPDATE_ACTIVITY_SUBCOVERAGE_FAILURE,
    DELETE_ACTIVITY_SUBCOVERAGE_REQUEST,
    DELETE_ACTIVITY_SUBCOVERAGE_SUCCESS,
    DELETE_ACTIVITY_SUBCOVERAGE_FAILURE,
} from '../actions/dataActions';
import { getActivitySubcoverages, getActivitySubcoverageById, createActivitySubcoverage, updateActivitySubcoverage, deleteActivitySubcoverage } from '../../services/api';
import { handleApiError } from '../../utils/errorHandler';

function* fetchActivitySubcoveragesSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getActivitySubcoverages, params);
        yield put({ type: FETCH_ACTIVITY_SUBCOVERAGES_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des sous-couvertures activités');
        yield put({ type: FETCH_ACTIVITY_SUBCOVERAGES_FAILURE, payload: errorMessage });
    }
}

function* fetchActivitySubcoverageByIdSaga(action) {
    try {
        const data = yield call(getActivitySubcoverageById, action.payload);
        yield put({ type: FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement du détail de la sous-couverture activité');
        yield put({ type: FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_FAILURE, payload: errorMessage });
    }
}

function* createActivitySubcoverageSaga(action) {
    try {
        const { referenceId, subcoverageData } = action.payload;
        const data = yield call(createActivitySubcoverage, referenceId, subcoverageData);
        yield put({ type: CREATE_ACTIVITY_SUBCOVERAGE_SUCCESS, payload: data });
        // Rafraîchir la liste des sous-couvertures après création
        yield put({ type: FETCH_ACTIVITY_SUBCOVERAGES_REQUEST, payload: {} });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la création de la sous-couverture activité');
        yield put({ type: CREATE_ACTIVITY_SUBCOVERAGE_FAILURE, payload: errorMessage });
    }
}

function* updateActivitySubcoverageSaga(action) {
    try {
        const { subcoverageId, payload } = action.payload;
        const data = yield call(updateActivitySubcoverage, subcoverageId, payload);
        yield put({ type: UPDATE_ACTIVITY_SUBCOVERAGE_SUCCESS, payload: data });
        // Rafraîchir le détail de la sous-couverture
        yield put({ type: FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_REQUEST, payload: subcoverageId });
        // Rafraîchir la liste des sous-couvertures après mise à jour
        yield put({ type: FETCH_ACTIVITY_SUBCOVERAGES_REQUEST, payload: { forceRefresh: true } });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la mise à jour de la sous-couverture activité');
        yield put({ type: UPDATE_ACTIVITY_SUBCOVERAGE_FAILURE, payload: errorMessage });
        // Rafraîchir la liste même en cas d'erreur pour s'assurer de la cohérence
        yield put({ type: FETCH_ACTIVITY_SUBCOVERAGES_REQUEST, payload: { forceRefresh: true } });
    }
}

function* deleteActivitySubcoverageSaga(action) {
    try {
        const subcoverageId = action.payload;
        const data = yield call(deleteActivitySubcoverage, subcoverageId);
        yield put({ type: DELETE_ACTIVITY_SUBCOVERAGE_SUCCESS, payload: data });
        // Rafraîchir la liste des sous-couvertures après suppression
        yield put({ type: FETCH_ACTIVITY_SUBCOVERAGES_REQUEST, payload: { forceRefresh: true } });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la suppression de la sous-couverture activité');
        yield put({ type: DELETE_ACTIVITY_SUBCOVERAGE_FAILURE, payload: errorMessage });
        // Rafraîchir la liste même en cas d'erreur pour s'assurer de la cohérence
        yield put({ type: FETCH_ACTIVITY_SUBCOVERAGES_REQUEST, payload: { forceRefresh: true } });
    }
}

export function* watchActivitySubcoveragesRequests() {
    yield takeEvery(FETCH_ACTIVITY_SUBCOVERAGES_REQUEST, fetchActivitySubcoveragesSaga);
    yield takeEvery(FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_REQUEST, fetchActivitySubcoverageByIdSaga);
    yield takeEvery(CREATE_ACTIVITY_SUBCOVERAGE_REQUEST, createActivitySubcoverageSaga);
    yield takeEvery(UPDATE_ACTIVITY_SUBCOVERAGE_REQUEST, updateActivitySubcoverageSaga);
    yield takeEvery(DELETE_ACTIVITY_SUBCOVERAGE_REQUEST, deleteActivitySubcoverageSaga);
}

